import Smartphones from './containers/Smartphones'
import Tablets from './containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const FinanceDetailsByAccountView = getCurrentDeviceView(Smartphones, Tablets)

export default FinanceDetailsByAccountView
